import memoizeOne from 'memoize-one'
import { pipe, prop, props as pluckAll } from 'ramda'

import { shallowEquals } from '~/src/Lib/Utils'

export const CHART_PADDING = {
  top: 16,
  right: 20,
  bottom: 40,
  left: 0,
}
const breakpointPadding = {
  xs: {
    // Only enough room to avoid clipping strokes and endpoint markers.
    top: 4,
    right: 4,
  },
}
const paddingPlucker = pipe(prop(0), pluckAll(['xOffset', 'width', 'breakpoint']))

export const getPaddingForChart = memoizeOne(
  (props, paddingLookup = breakpointPadding) => {
    const { xOffset: offsetRight } = props
    const { right: defaultRight } = CHART_PADDING
    const breakpoint = props.width || props.breakpoint
    const breakpointOverrides = paddingLookup[breakpoint]

    return {
      ...CHART_PADDING,
      ...breakpointOverrides,
      right: offsetRight + (breakpointOverrides?.right ?? defaultRight),
    }
  },
  (left, right) => shallowEquals(paddingPlucker(left), paddingPlucker(right)) && shallowEquals(left[1], right[1]),
)
